<template>
	<div :class="mainClass">
		<div class="auth-layout">
			<auth-header v-if="!isPlansNew && !isRevertSecondFactorAddition" />
			<div class="overflow-x-hidden">
				<nuxt />
			</div>
		</div>
		<div>
			<chat />
			<modal />
			<toaster />
		</div>
		<pixellot-footer v-if="!isPlansNew && !isRevertSecondFactorAddition" />
	</div>
</template>

<script>
import AuthHeader from '~/components/AuthHeader'
import PixellotFooter from '~/components/PixellotFooter'
import { Modal, Toaster } from '~/components/managers'
import Chat from '~/components/interface/Chat'

export default {
	name: 'Auth',
	components: {
		Chat,
		Modal,
		Toaster,
		AuthHeader,
		PixellotFooter
	},
	computed: {
		mainClass () {
			switch (this.$route.name) {
					case 'plans':
					case 'resellers':
					case 'campaign-thanksgiving':
					case 'sign-up':
					case 'sign-up-success':
					case 'auth-user-sign-up':
					case 'auth-user-sign-up-success':
						return 'bg-white'
					case 'info-payment-failure':
					case 'info-payment-success':
						return 'info-container bg-white'
					default:
						return 'bg-content'
			}
		},
		isPlansNew () {
			return this.$route.name === 'plans-new'
		},
		isRevertSecondFactorAddition () {
			return this.$route.name === 'auth-actions-revert-second-factor-addition'
		}
	}
}
</script>
